// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2RQZB","info":"UpdateTermsInfo_info__3-TJ5"};